// extracted by mini-css-extract-plugin
export default {"box":"TravelModuleAdminCalendar_box__AFbLg","customSelectBox":"TravelModuleAdminCalendar_customSelectBox__CDFVY"};